import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface Tuition {
  subscriptionId?: string;
  enrollmentName: string;
  enrollmentId: string;
  baseAmount: number;
  finalAmount: number;
  billingCycle: string;
  status?: string;
}

interface GetStudentTuitionDetails {
  studentId: string;
  status?: 'active' | 'paused';
}

export const getStudentTuitionDetails = async ({
  studentId,
  ...params
}: GetStudentTuitionDetails) => {
  const response = await baseAPI.get<Array<Tuition>>(
    `/students/${studentId}/tuition-details`,
    { params },
  );
  return response.data;
};

export const useGetStudentTuitionDetails = (
  params: GetStudentTuitionDetails,
) => {
  return useQuery({
    queryKey: [
      params.status
        ? params.status === 'active'
          ? KEYS.ACTIVE_TUITION_DETAILS
          : KEYS.PAUSED_TUITION_DETAILS
        : KEYS.TUITION_DETAILS,
      params.studentId,
    ],
    queryFn: () => getStudentTuitionDetails(params),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
